<template>
	<div class="form-group row">
		<label :for="label" class="col-sm-3 col-form-label">{{formatTitle(label)}}</label>
		<div class="col-sm-9">
			<input type="number" class="form-control" :id="label" :value="value" v-on:input="$emit('input', parseInt($event.target.value)||0)">
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'value',
		'label'
	],
	methods: { 
		formatTitle (input) {
			return input.replace(/_+/g,' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
		}
	}
}
</script>

<style scoped>

</style>